<template>
  <div>
    <div class="jiayoutop">
      <img class="jiayoubanner" src="../../../static/jiayoubanner.png" />
    </div>
    <div class="jiayouList_dingwei" @click="buttonClicked? '' : showMask1()">
      <img src="/static/whiteLocate.png" class="jiayouList_dingweiicon" />
      <div class="jiayouList_dingweiname">{{ city ? city : '定位中...' }}</div>
    </div>
    <div class="jiayoucenterbox">
      <div class="jiayouclassbox">
        <div v-for="(item,index) in claatab" @click="changeclaatab(index)" :class="item.select ? 'jiayouclass' : 'jiayouclass1'">{{item.name}}</div>
      </div>
      <div class="jiayoubox1" v-for="(item,index) in oilStationsList" @click="toDetail(item.station_id)">
        <div class="jiayouboxtop">
          <div class="jiayouname">{{item.name}}</div>
          <div class="jiayoujulibox">
            <img class="jiayoujuliicon" src="../../../static/juli.png" />
            <div class="jiayoujuli">{{item.distance_str}}</div>
          </div>
        </div>
        <div class="jiayouaddress">{{item.address}}</div>
        <div class="jiayouprice"><span style="font-size: 15px;">￥</span>{{item.price.priceGun}}</div>
      </div>
      <div class="jiayounone"></div>
    </div>
    <!-- 弹出层 开始 -->
    <!-- <van-popup v-model="show" position="top" :style="{ height: '30%' }">内容</van-popup> -->
    <!-- <transition name="fade">
      <div class="maskPanel" v-if="!isMaskHidden" @click=" buttonClicked ? '' : showMask1() " id="showMask">
        <div class="maskCont">
          <div class="maskdiv" v-for="(item,index) in cityList" :key="index" @click="tap(item)">
            {{ item }}
          </div>
        </div>
      </div>
    </transition> -->
    <!-- 弹出层 结束 -->
    <taber></taber>
  </div>
</template>

<script>
  import taber from '@/components/taber/taber'
  import httper from '../../api/http';
  import {
    Dialog
  } from 'vant';
  export default {
    components: {
      taber
    },
    data() {
      return {
        claatab: [{
          name: "综合排序",
          id: 1,
          select: true
        }, {
          name: "距离优先",
          id: 2,
          select: false
        }, {
          name: "价格优先",
          id: 3,
          select: false
        }],
        page: 1,
        page_size: 20,
        storeFlag: true, // 服务商家列表能否下拉分页,默认为true
        city: "", // 用户所在市区,默认为空中山市
        longitude: "113.3926", //经度
        latitude: "22.51595", //纬度
        cityStatus: false, // 用户是否手动选择市区,默认为false
        cityList: [
          "广州市",
          "韶关市",
          "深圳市",
          "珠海市",
          "汕头市",
          "佛山市",
          "江门市",
          "湛江市",
          "茂名市",
          "肇庆市",
          "惠州市",
          "梅州市",
          "汕尾市",
          "河源市",
          "阳江市",
          "清远市",
          "东莞市",
          "中山市",
          "潮州市",
          "揭阳市",
          "云浮市"
        ], // 接口获取市区列表
        isMaskHidden: true, // 是否隐藏遮盖层,默认为true
        buttonClicked: false, // 防止用户重复点击
        locationCount: 0, //地址请求次数
        loads: 0,
        wechatmesg: {}, //微信参数
        oilStationsList: [], //加油站列表

      }
    },
    created() {
      this.getwechat({
        url: location.href.split('#')[0]
      })
      if (!sessionStorage.getItem("latitude") || !sessionStorage.getItem("longitude") || !sessionStorage.getItem("city")) {
        // this.getMyLocation()
        this.getWxLocation()
      }
      //获取纬度
      if (sessionStorage.getItem("latitude")) {
        this.latitude = sessionStorage.getItem("latitude")
      }
      //获取经度
      if (sessionStorage.getItem("longitude")) {
        this.longitude = sessionStorage.getItem("longitude")
      }
      //获取城市
      if (sessionStorage.getItem("city")) {
        this.city = sessionStorage.getItem("city")
      }

      let requestData = {};
      requestData.lat = this.latitude;
      requestData.lng = this.longitude;
      // requestData.city = this.city;
      requestData.page = this.page;
      requestData.page_size = this.page_size;
      this.request("oilStations", requestData);
    },
    mounted() {

    },
    methods: {
      toDetail(id) {
        // this.$router.push({
        //   path: "/jiayouDetail"
        // })
        let that = this
        this.$router.push({
          path: "/jiayouDetail",
          query: {
            id: id,
            lng: that.longitude,
            lat: that.latitude,
          }
        })
      },
      changeclaatab(indexStr){
        let that = this
        let clastab = this.claatab
        for(let i=0;i<clastab.length;i++){
          if(indexStr==i){
            that.claatab[i].select = true
          }else{
            that.claatab[i].select = false
          }
        }
      },
      // 展示/隐藏遮盖层
      showMask1() {
        this.isMaskHidden = !this.isMaskHidden;
      },
      //获取微信配置信息接口
      getwechat(requestData = {}) {
        console.log('getwechat 1')
        httper.get("wechat/wechat/sign-package", requestData, res => {
          console.log(res);
          //wx.ready(() => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: res.appId, // 必填，公众号的唯一标识
            timestamp: res.timestamp, // 必填，生成签名的时间戳
            nonceStr: res.nonceStr, // 必填，生成签名的随机串
            signature: res.signature, // 必填，签名
            jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表
          });
        })

        //});
      },
      getWxLocation() {
        let that = this
        wx.ready(() => {
          console.log('wx ready', "yes")
          wx.getLocation({
            type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
            success: function(res) {
              console.log("wx.getLocation", res)
              var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
              var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
              var speed = res.speed; // 速度，以米/每秒计
              var accuracy = res.accuracy; // 位置精度
              that.latitude = latitude;
              that.longitude = longitude;
              sessionStorage.setItem("latitude", latitude)
              sessionStorage.setItem("longitude", longitude)
              var geocoder = new qq.maps.Geocoder();
              var latLng = new qq.maps.LatLng(latitude, longitude);
              //设置服务请求成功的回调函数
              geocoder.setComplete(function(result) {
                console.log(result.detail);
                that.city = result.detail.addressComponents.city
                sessionStorage.setItem("city", result.detail.addressComponents.city)
              });
              //若服务请求失败，则运行以下函数
              geocoder.setError(function() {

              });
              //对指定经纬度进行解析
              geocoder.getAddress(latLng);
              let requestData = {};
              requestData.lat = that.latitude;
              requestData.lng = that.longitude;
              requestData.page = that.page;
              requestData.page_size = that.page_size;
              that.request("oilStations", requestData);
              console.log('oilStations requestData 2', requestData)
            }
          });
        });
      },
      //获取城市定位
      tap(city) {
        // this.city = city;
        this.page = 1;
        let requestData = {};
        // requestData.product_id = this.product_id;
        // requestData.city = this.city;
        requestData.page = this.page;
        requestData.page_size = this.page_size;
        this.oilStationsList = []
        this.request("oilStations", requestData);
      },
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true;
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === "number") {
            setTimeout(() => {
              this.buttonClicked = false;
            }, duration);
          }
          resolve(true);
        });
      },
      request(type = "", requestData = {}) {
        let that = this;
        let data = {};
        switch (type) {
          // 获取城市列表
          case "getCityList":
            httper.get("/index/city-list", requestData, res => {
              console.log("城市列表", res);
              // data.storeList = that.storeList
              // for (let i in res.data) data.storeList.push(res.data[i])
              if (res.data.length > 0) {
                that.cityList = res.data;
              }
            }, false);
            break;
            //获取微信参数
          case "getWechat":
            httper.get("/wechat/wechat/sign-package", requestData, res => {
              console.log("微信参数", res);
              this.wechatmesg = res
              console.log("wechatmesg", this.wechatmesg)

            }, true);
            break;
            // 加油站列表
          case "oilStations":
            httper.post("oil/stations", requestData, res => {
              that.loads = 1;
              console.log("res", res)
              if (res.code == 0) {
                console.log("length", res.data.length)
                let oilStationsList = that.oilStationsList;
                that.storeFlag = res.data.length - 20 === 0
                for (let i = 0; i < res.data.length; i++) {
                  oilStationsList.push(res.data[i]);
                }
                that.oilStationsList = oilStationsList;
              } else {
                this.$toast({
                  message: res.message || '系统异常',
                })
              }
            }, false);
            break
        }
      },
      getmore() {
        let that = this
        console.log("获取更多")
        if (!that.storeFlag) {
          this.$toast({
            message: '没有更多了'
          })
          return
        }
        let page = (that.storePage) + 1
        that.storePage = page
        let requestData = {};
        requestData.product_id = this.product_id;
        requestData.lat = this.latitude;
        requestData.lng = this.longitude;
        requestData.city = this.city;
        requestData.page = this.storePage;
        requestData.page_size = this.page_size;
        this.request("getStoreList", requestData);
      },
    }
  }
</script>

<style scoped="scoped">
  .jiayoutop {
    width: 100%;
    height: 191px;
  }

  .jiayoubanner {
    width: 100%;
    height: 100%;
  }

  .jiayoucenterbox {
    width: 100%;
    position: absolute;
    top: 175px;
    background: #F7F7F7;
    border-radius: 15px 15px 0px 0px;
    padding: 16px 20px;
    box-sizing: border-box;

  }

  .jiayouclassbox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 22px;
  }

  .jiayouclass {
    width: 84px;
    height: 27px;
    background: rgba(253, 140, 0, 0.1500);
    border: 1px solid #FD8C00;
    border-radius: 13px;
    font-size: 15px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jiayouclass1 {
    width: 84px;
    height: 27px;
    font-size: 15px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .jiayoubox {
    width: 100%;
    background: #FFFFFF;
    border: 2px solid #FD8C00;
    border-radius: 8px;
    padding: 19px 16px;
    box-sizing: border-box;
    margin-bottom: 13px;
  }

  .jiayoubox1 {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 19px 16px;
    box-sizing: border-box;
    margin-bottom: 13px;
  }

  .jiayouboxtop {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .jiayouname {
    font-size: 15px;
    color: #000000;
    font-weight: bold;
  }

  .jiayoujulibox {
/*    width: 69px; */
    height: 25px;
    background: #D2EAF8;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 7px;
    box-sizing: border-box;
  }

  .jiayoujuliicon {
    width: 14px;
    height: 14px;
    margin-right: 4px;
  }

  .jiayoujuli {
    font-size: 12px;
    color: #000000;
  }

  .jiayouaddress {
    font-size: 12px;
    color: #666666;
    margin-bottom: 33px;
  }

  .jiayouprice {
    font-size: 27px;
    color: #FD8C00;
  }

  .jiayouList_dingwei {
    display: flex;
    align-items: center;
    position: absolute;
    top: 20px;
    right: 20px;
    /* width: 90%;
    padding: 20px; */
  }

  .jiayouList_dingweiicon {
    width: 20px;
    height: 20px;
  }

  .jiayouList_dingweiname {
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .jiayounone {
    width: 100%;
    height: 50px;

  }
</style>



// WEBPACK FOOTER //
// src/pages/jiayou/jiayou.vue